<template>
  <div v-if="hasBushCountPriceRange" class="ls-suggested-instant-quote-item">
    <div>
      <LsServiceEventItemHeader
        :service-name="'Bush Trimming Quote: Additional Details Required'"
        is-quote
      />
      <p class="has-text-weight-bold" test-id="rangeQuote">{{ priceRangeString }}</p>
    </div>
    <LsButton
      class="ls-suggested-instant-quote-item--button"
      text="confirm details"
      bg-color="primary"
      text-color="white"
      track-id="ls_suggested_instant_quote_item-confirm_details"
      test-id="confirm_details"
      @click="$emit('click')"
    />
  </div>
  <div v-else class="ls-suggested-instant-quote-item">
    <div>
      <LsServiceEventItemHeader :service-name="`Suggested Service - ${serviceName}`" is-quote />
      <p v-if="suggestion.price" class="has-text-weight-bold" test-id="price">{{ priceString }}</p>
      <p v-else test-id="no_price">{{ description }}</p>
    </div>
    <LsButton
      class="ls-suggested-instant-quote-item--button"
      text="get instant quote"
      bg-color="primary"
      text-color="white"
      track-id="ls_suggested_instant_quote_item-get_instant_quote"
      test-id="get_instant_quote"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import LsServiceEventItemHeader from '@/components/ServiceItems/LsServiceEventItemHeader/LsServiceEventItemHeader.vue';
import { lsFilters, lsPropTypeHelpers } from 'ls-vue-common';
import { LsButton } from '@/components/common';
import _ from 'lodash';

export default {
  name: 'LsSuggestedInstantQuoteItem',
  components: {
    LsButton,
    LsServiceEventItemHeader,
  },
  props: {
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    suggestion: VueTypes.shape({
      price: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
      price_range_min: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
      price_range_max: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
      type: VueTypes.string.isRequired,
      instant_quotable_type: VueTypes.string,
    }).isRequired.loose,
  },
  computed: {
    iqObject() {
      return _.get(this.suggestion, `${this.suggestion.instant_quotable_type}`);
    },
    description() {
      return this.iqObject ? this.iqObject.copy.action : this.suggestion.copy.description;
    },
    serviceName() {
      return this.iqObject ? this.iqObject.service.name : this.suggestion.copy.name;
    },
    priceString() {
      return `Quote - ${lsFilters.currency({
        amount: this.suggestion.price,
      })} ${this.description}`;
    },
    priceRangeString() {
      return `${lsFilters.currency({
        amount: this.suggestion.price_range_min,
      })}–${lsFilters.currency({
        amount: this.suggestion.price_range_max,
      })} to trim ${this.bushCountRangeMin}–${this.bushCountRangeMax} bushes`;
    },
    hasBushCountPriceRange() {
      return (
        _.get(this.suggestion, 'price_range_min') &&
        _.get(this.suggestion, 'price_range_max') &&
        this.bushCountRangeMin &&
        this.bushCountRangeMax
      );
    },
    bushCountRangeMin() {
      return _.get(this.suggestion, 'instant_quote_bush_trimming.bush_count_range_min');
    },
    bushCountRangeMax() {
      return _.get(this.suggestion, 'instant_quote_bush_trimming.bush_count_range_max');
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-suggested-instant-quote-item {
  padding: 20px;
  margin: 20px 0;
  background: $primary-light;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.ls-suggested-instant-quote-item--button {
  margin-left: auto;
  @media (max-width: $mobile-max-width) {
    margin-top: 20px;
  }
}

.themed-app {
  .ls-suggested-instant-quote-item {
    background: $theme-color-primary-light;
  }
}
</style>
